// Мультиязычность копилота: ru + бразильский португальский.
//
// Локаль определяет ТРИ вещи, а не только надписи:
//   1. язык интерфейса (эти словари)
//   2. язык распознавания речи в Deepgram — speechLang()
//   3. сценарий продаж в as_ai_scenario, откуда PHP берёт системный промпт — scenarioName()
// Поэтому переключение языка = перезапуск звонка, на лету менять нельзя.
import { createI18n } from 'vue-i18n'
import ru from './locales/ru.json'
import pt from './locales/pt.json'

export const SUPPORTED = ['ru', 'pt']
const STORAGE_KEY = 'copilot_lang'

/** Локаль: ?lang= в URL → localStorage → язык браузера → ru. */
export function detectLocale () {
  try {
    const fromUrl = new URLSearchParams(location.search).get('lang')
    if (fromUrl && SUPPORTED.includes(fromUrl)) {
      localStorage.setItem(STORAGE_KEY, fromUrl)
      return fromUrl
    }
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && SUPPORTED.includes(saved)) return saved
    const nav = (navigator.language || '').toLowerCase()
    if (nav.startsWith('pt')) return 'pt'
  } catch (e) { /* приватный режим — молча падаем в дефолт */ }
  return 'ru'
}

export function setLocale (locale) {
  if (!SUPPORTED.includes(locale)) return
  i18n.global.locale.value = locale
  try { localStorage.setItem(STORAGE_KEY, locale) } catch (e) { /* ignore */ }
  document.documentElement.setAttribute('lang', locale === 'pt' ? 'pt-BR' : locale)
}

/**
 * Код языка для Deepgram. Для португальского нужен именно 'pt-BR':
 * generic 'pt' у nova-3 тянет к европейскому произношению и хуже держит
 * бразильскую редукцию гласных.
 */
export function speechLang (locale = i18n.global.locale.value) {
  return locale === 'pt' ? 'pt-BR' : 'ru'
}

/** Имя сценария в as_ai_scenario — из него sales-demo-chat.php берёт системный промпт. */
export function scenarioName (locale = i18n.global.locale.value) {
  return locale === 'pt' ? 'demo_pt' : 'demo'
}

/**
 * Блок инструкций, который уходит в LLM в extra_context. Берём из сырого JSON,
 * а не через tm()/rt() — нужен обычный массив строк, а не обёртки vue-i18n.
 */
const RAW = { ru, pt }
export function extraContext (locale = i18n.global.locale.value) {
  return (RAW[locale] || RAW.ru).prompt.extraContext.join('\n')
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: 'ru',
  messages: { ru, pt },
})

document.documentElement.setAttribute('lang', i18n.global.locale.value === 'pt' ? 'pt-BR' : 'ru')

export default i18n
